define('SageDotCom/DataLayer/Global/iAdvizeCallBack',[
    "jquery",
    "SageDotCom/DataLayer/Events/iAdvizeCallBack"
],
    function ($, iAdvizeCallBackInteractionEvent) {

        function iAdvizeCallBackTracker() {
            this.scope = document.querySelector('.iadvise-callback');
        }

        iAdvizeCallBackTracker.prototype.start = function () {
            MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

            // This will look for iAdvize CallBack to exist on the page and once it is found then it will disconnect the observer
            var observer = new MutationObserver(function (mutations, observer) {
                // fired when a mutation occurs
                var el = document.querySelector('.iadvise-callback');
                if (el) {
                    this.scope = el;
                    console.warn("iAdvize Callback component was found");
                    $(el).on("click", onLinkClick);

                    // This will disconnect once the element has been found
                    observer.disconnect();
                }
            });

            // define what element should be observed by the observer
            // and what types of mutations trigger the callback
            observer.observe(document, {
                childList: true,
                characterData: true,
                subtree: true
            });

            // If after some time has passed (~1 min) automatically disconnect the observer so it will stop looking for the element
            setTimeout(function () {
                observer.disconnect();
                console.warn("Disconnecting observation for iAdvize Callback");
            }, 60000);
        }

        function onLinkClick(e) {
            new iAdvizeCallBackInteractionEvent(e.currentTarget).trigger();
        }

        return iAdvizeCallBackTracker;
    });
